export default [
  {
    path: '/agencies/agents',
    name: 'agency-agents-index',
    component: () => import('@/views/agency/agents/AgentList.vue'),
    meta: {
      title: 'Agents',
      pageTitle: 'Agencies',
      breadcrumb: [
        {
          text: 'Agents',
          active: true,
        },
      ],
      resource: 'Agent',
      action: 'read',
    },
  },
  {
    path: '/agencies/agents/:id/show',
    name: 'agency-agents-show',
    component: () => import('@/views/agency/agents/AgentDetail.vue'),
    meta: {
      title: 'Agent Details',
      pageTitle: 'Agencies',
      navActiveLink: 'agency-agents-index',
      breadcrumb: [
        {
          text: 'Agents',
          to: '/agencies/agents',
        },
      ],
      resource: 'Agent',
      action: 'read',
    },
  },
  {
    path: '/agencies/agents/:id/edit',
    name: 'agency-agents-edit',
    component: () => import('@/views/agency/agents/AgentEdit.vue'),
    meta: {
      title: 'Agent Edit',
      pageTitle: 'Agencies',
      navActiveLink: 'agency-agents-index',
      breadcrumb: [
        {
          text: 'Agents',
          to: '/agencies/agents',
        },
      ],
      resource: 'Agent',
      action: 'update',
    },
  },
  {
    path: '/agencies/agents/probationary/:id/show',
    name: 'agency-agents-probationary-show',
    component: () => import('@/views/agency/agents/ProbationaryAgentDetail.vue'),
    meta: {
      title: 'Probationary Agent Details',
      pageTitle: 'Agencies',
      navActiveLink: 'agency-agents-index',
      breadcrumb: [
        {
          text: 'Agents',
          to: '/agencies/agents',
        },
      ],
      resource: 'Agent',
      action: 'read',
    },
  },
  {
    path: '/agencies/agents/probationary/:id/edit',
    name: 'agency-agents-probationary-edit',
    component: () => import('@/views/agency/agents/ProbationaryAgentEdit.vue'),
    meta: {
      title: 'Probationary Agent Edit',
      pageTitle: 'Agencies',
      navActiveLink: 'agency-agents-index',
      breadcrumb: [
        {
          text: 'Agents',
          to: '/agencies/agents',
        },
      ],
      resource: 'Agent',
      action: 'update',
    },
  },
  {
    path: '/agencies/requests/agents',
    name: 'agencies-agent-profile-update-index',
    component: () => import('@/views/agency/requests/List.vue'),
    meta: {
      title: 'Agent Requests List',
      pageTitle: 'Agencies',
      breadcrumb: [
        {
          text: 'Agent Requests',
          active: true,
        },
      ],
      resource: 'AgentRequest',
      action: 'read',
    },
  },
  {
    path: '/agencies/requests/agents/:id/view',
    name: 'agencies-agent-profile-update-view',
    component: () => import('@/views/agency/requests/Detail.vue'),
    meta: {
      title: 'Agent Requests Detail',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-agent-profile-update-index',
      breadcrumb: [
        {
          text: 'Agent Requests',
          active: true,
        },
      ],
      resource: 'AgentRequest',
      action: 'show',
    },
  },
  {
    path: '/agencies/articles/:type',
    name: 'agencies-articles-index',
    component: () => import('@/views/agency/articles/ArticleList.vue'),
    meta: {
      title: 'Article List',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-articles-index',
      breadcrumb: [
        {
          text: 'Articles',
          active: true,
        },
      ],
      resource: 'AgentArticle',
      action: 'read',
    },
  },
  {
    path: '/agencies/articles/new/create',
    name: 'agencies-articles-create',
    component: () => import('@/views/agency/articles/ArticleCreate.vue'),
    meta: {
      title: 'Article Create',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-articles-index',
      breadcrumb: [
        {
          text: 'Articles',
          to: '/agencies/articles/all-article',
        },
        {
          text: 'Create new Article',
          active: true,
        },
      ],
      resource: 'AgentArticle',
      action: 'create',
    },
  },
  {
    path: '/agencies/articles/:id/edit',
    name: 'agencies-articles-edit',
    component: () => import('@/views/agency/articles/ArticleEdit.vue'),
    meta: {
      title: 'Edit Article',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-articles-index',
      breadcrumb: [
        {
          text: 'Articles',
          to: '/agencies/articles/all-article',
        },
        {
          text: 'Edit Article',
          active: true,
        },
      ],
      resource: 'AgentArticle',
      action: 'update',
    },
  },
  {
    path: '/agencies/articles/:id/show',
    name: 'agencies-articles-show',
    component: () => import('@/views/agency/articles/ArticleDetail.vue'),
    meta: {
      title: 'Article Detail',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-articles-index',
      breadcrumb: [
        {
          text: 'Articles',
          to: '/agencies/articles/all-article',
        },
        {
          text: 'Article Detail',
          active: true,
        },
      ],
      resource: 'AgentArticle',
      action: 'show',
    },
  },
  {
    path: '/agencies/article-categories/:type',
    name: 'agencies-article-categories-index',
    component: () => import('@/views/agency/categories/CategoryList.vue'),
    meta: {
      title: 'Article Category List',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-article-categories-index',
      breadcrumb: [
        {
          text: 'Article Category',
          active: true,
        },
      ],
      resource: 'AgentArticleCategory',
      action: 'read',
    },
  },
  {
    path: '/agencies/article-categories/new/create',
    name: 'agencies-article-categories-create',
    component: () => import('@/views/agency/categories/CategoryCreate.vue'),
    meta: {
      title: 'Article Category Create',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-article-categories-index',
      breadcrumb: [
        {
          text: 'Article Category',
          to: '/agencies/article-categories/all-article-category',
        },
        {
          text: 'Create new Article Category',
          active: true,
        },
      ],
      resource: 'AgentArticleCategory',
      action: 'create',
    },
  },
  {
    path: '/agencies/article-categories/:id/edit',
    name: 'agencies-article-categories-edit',
    component: () => import('@/views/agency/categories/CategoryEdit.vue'),
    meta: {
      title: 'Edit Article Category',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-article-categories-index',
      breadcrumb: [
        {
          text: 'Article Category',
          to: '/agencies/article-categories/all-article-category',
        },
        {
          text: 'Edit Article Category',
          active: true,
        },
      ],
      resource: 'AgentArticleCategory',
      action: 'update',
    },
  },
  {
    path: '/agencies/article-categories/:id/show',
    name: 'agencies-article-categories-show',
    component: () => import('@/views/agency/categories/CategoryDetail.vue'),
    meta: {
      title: 'Article Category Detail',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-article-categories-index',
      breadcrumb: [
        {
          text: 'Article Category',
          to: '/agencies/article-categories/all-article-category',
        },
        {
          text: 'Article Category Detail',
          active: true,
        },
      ],
      resource: 'AgentArticleCategory',
      action: 'show',
    },
  },
  {
    path: '/agencies/announcement-categories/:type',
    name: 'agencies-announcement-categories-index',
    component: () => import('@/views/agency/announcement-category/CategoryList.vue'),
    meta: {
      title: 'Announcement Category List',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-announcement-categories-index',
      breadcrumb: [
        {
          text: 'Announcement Categories',
          active: true,
        },
      ],
      resource: 'AnnouncementCategory',
      action: 'read',
    },
  },
  {
    path: '/agencies/announcement-categories/new/create',
    name: 'agencies-announcement-categories-create',
    component: () => import('@/views/agency/announcement-category/CategoryCreate.vue'),
    meta: {
      title: 'Announcement Category Create',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-announcement-categories-index',
      breadcrumb: [
        {
          text: 'Announcement Categories',
          to: '/agencies/announcement-categories/all-announcement-category',
        },
        {
          text: 'Create new Announcement Category',
          active: true,
        },
      ],
      resource: 'AnnouncementCategory',
      action: 'create',
    },
  },
  {
    path: '/agencies/announcement-categories/:id/edit',
    name: 'agencies-announcement-categories-edit',
    component: () => import('@/views/agency/announcement-category/CategoryEdit.vue'),
    meta: {
      title: 'Edit Announcement Category',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-announcement-categories-index',
      breadcrumb: [
        {
          text: 'Announcement Categories',
          to: '/agencies/announcement-categories/all-announcement-category',
        },
        {
          text: 'Edit Announcement Category',
          active: true,
        },
      ],
      resource: 'AnnouncementCategory',
      action: 'update',
    },
  },
  {
    path: '/agencies/announcement-categories/:id/show',
    name: 'agencies-announcement-categories-show',
    component: () => import('@/views/agency/announcement-category/CategoryDetail.vue'),
    meta: {
      title: 'Announcement Category Detail',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-announcement-categories-index',
      breadcrumb: [
        {
          text: 'Announcement Categories',
          to: '/agencies/announcement-categories/all-announcement-category',
        },
        {
          text: 'Announcement Category Detail',
          active: true,
        },
      ],
      resource: 'AnnouncementCategory',
      action: 'show',
    },
  },

  {
    path: '/agencies/announcement/:type',
    name: 'agencies-announcements-index',
    component: () => import('@/views/agency/announcements/AnnouncementList.vue'),
    meta: {
      title: 'Announcement List',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-announcements-index',
      breadcrumb: [
        {
          text: 'Announcements',
          active: true,
        },
      ],
      resource: 'Announcement',
      action: 'read',
    },
  },
  {
    path: '/agencies/announcement/new/create',
    name: 'agencies-announcements-create',
    component: () => import('@/views/agency/announcements/AnnouncementCreate.vue'),
    meta: {
      title: 'Announcement Create',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-announcements-index',
      breadcrumb: [
        {
          text: 'Announcements',
          to: '/agencies/announcement/all-announcement',
        },
        {
          text: 'Create new Announcement',
          active: true,
        },
      ],
      resource: 'Announcement',
      action: 'create',
    },
  },
  {
    path: '/agencies/announcement/:id/edit',
    name: 'agencies-announcements-edit',
    component: () => import('@/views/agency/announcements/AnnouncementEdit.vue'),
    meta: {
      title: 'Edit Announcement',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-announcements-index',
      breadcrumb: [
        {
          text: 'Announcements',
          to: '/agencies/announcement/all-announcement',
        },
        {
          text: 'Edit Announcement',
          active: true,
        },
      ],
      resource: 'Announcement',
      action: 'update',
    },
  },
  {
    path: '/agencies/announcement/:id/show',
    name: 'agencies-announcements-show',
    component: () => import('@/views/agency/announcements/AnnouncementDetail.vue'),
    meta: {
      title: 'Announcement Detail',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-announcements-index',
      breadcrumb: [
        {
          text: 'Announcements',
          to: '/agencies/announcement/all-announcement',
        },
        {
          text: 'Announcement Detail',
          active: true,
        },
      ],
      resource: 'Announcement',
      action: 'show',
    },
  },

  {
    path: '/agencies/reservation-settings',
    name: 'agencies-reservation-settings',
    component: () => import('@/views/agency/settings/Index.vue'),
    meta: {
      title: 'Reservation Settings',
      pageTitle: 'Agencies',
      breadcrumb: [
        {
          text: 'Settings',
          active: true,
        },
      ],
      resource: 'ReservationSetting',
      action: 'create',
    },
  },
  {
    path: '/agencies/reservation/:type',
    name: 'agencies-reservations-index',
    component: () => import('@/views/agency/reservation/ReservationList.vue'),
    meta: {
      title: 'Reservation List',
      pageTitle: 'Agencies',
      breadcrumb: [
        {
          text: 'Reservations',
          active: true,
        },
      ],
      resource: 'LotReservation',
      action: 'read',
    },
  },
  {
    path: '/agencies/reservation/new/create',
    name: 'agencies-reservation-create',
    component: () => import('@/views/agency/reservation/ReservationCreate.vue'),
    meta: {
      title: 'Reservation Create',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-reservations-index',
      breadcrumb: [
        {
          text: 'Reservations',
          to: '/agencies/reservation/reserved',
        },
        {
          text: 'Create new Reservation',
          active: true,
        },
      ],
      resource: ['LotReservation', 'LotReservation'],
      action: ['create', 'create-staff-hold'],
    },
  },
  {
    path: '/agencies/reservation/:id/show',
    name: 'agencies-reservation-show',
    component: () => import('@/views/agency/reservation/ReservationDetail.vue'),
    meta: {
      title: 'Reservation Detail',
      pageTitle: 'Agencies',
      navActiveLink: 'agencies-reservations-index',
      breadcrumb: [
        {
          text: 'Reservations',
          to: '/agencies/reservation/reserved',
        },
        {
          text: 'Reservation Detail',
          active: true,
        },
      ],
      resource: 'LotReservation',
      action: 'show',
    },
  },
]
